import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className, stopPropagation } from '../../utils/tools.js';
import './TS_Tabs.scss';
import { StorageKey } from '../../modules/ModuleFE_LocalStorage.js';
/**
 * Tabs made easy
 *
 *
 * <b>SCSS:</b>
 * ```scss
 * .ts-tabs {
 *   .ts-tabs__tabs-header {
 *     .ts-tabs__tab {}
 *     .ts-tabs__focusedTabId {}
 *     .unselectable {}
 *   }
 *
 *   .ts-tabs__content {}
 * }
 * ```
 */
export class TS_Tabs extends ComponentSync {
    constructor(p) {
        super(p);
    }
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.tabs = nextProps.tabs;
        state.selectedTabId = (nextProps.tabs.find(t => t.uid === nextProps.selectedTabId)?.uid)
            || this.getStorageKey()?.get('')
            || this.state?.selectedTabId
            || nextProps.tabs[0]?.uid;
        //Default to first tab if provided selectedTabId is not in the tabs list
        if (!state.tabs.find(tab => tab.uid === state.selectedTabId))
            state.selectedTabId = state.tabs[0].uid;
        return state;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.scrollToSelected)
            this.scrollToSelectedTab();
    }
    //######################### Logic #########################
    getStorageKey() {
        if (!this.props.id)
            return;
        return new StorageKey(`ts-tabs__${this.props.id}`, this.props.persistSelection);
    }
    selectOnClick = (e, tab) => {
        stopPropagation(e);
        if (tab.disabled)
            return;
        const selectedTabId = tab.uid;
        if (!selectedTabId)
            return;
        this.getStorageKey()?.set(selectedTabId);
        if (this.props.onSelected) {
            this.props.onSelected(selectedTabId);
            return;
        }
        this.setState({ selectedTabId });
    };
    scrollToSelectedTab = () => {
        if (!this.props.selectedTabId)
            return;
        const selectedTab = document.getElementById(this.props.selectedTabId);
        if (!selectedTab)
            return;
        const deltaRight = selectedTab.getBoundingClientRect().right - window.innerWidth;
        if (deltaRight <= 1)
            return;
        selectedTab.parentElement?.scroll({
            left: deltaRight,
            behavior: 'smooth',
        });
    };
    //######################### Render #########################
    render() {
        const tabs = this.state.tabs;
        if (!tabs)
            return '';
        const getTitle = (tab) => {
            if (typeof tab.title === 'function')
                return tab.title();
            return tab.title;
        };
        const getContent = (tab) => {
            if (!tab)
                return '';
            if (typeof tab.content === 'function')
                return tab.content();
            return tab.content;
        };
        const wrapperClass = _className('ts-tabs', this.props.className);
        const headerClass = _className('ts-tabs__tabs-header', this.props.tabsHeaderClass);
        const contentClass = _className('ts-tabs__content', this.props.tabsContentClass);
        return (_jsxs("div", { id: this.props.id, className: wrapperClass, "data-tab-key": this.state.selectedTabId, children: [_jsxs("div", { className: headerClass, children: [tabs.map(tab => {
                            const tabClasses = _className('ts-tabs__tab', 'unselectable', this.state.selectedTabId === tab.uid ? 'ts-tabs__focused' : undefined, tab.disabled
                                ? 'disabled'
                                : undefined);
                            return _jsx("div", { id: tab.uid, className: tabClasses, onClick: (e) => this.selectOnClick(e, tab), children: getTitle(tab) }, tab.uid);
                        }), _jsx("span", { className: 'ts-tabs__empty-tab' })] }), _jsx("div", { className: contentClass, children: getContent(tabs.find(tab => tab.uid === this.state.selectedTabId)) })] }));
    }
}
//# sourceMappingURL=TS_Tabs.js.map